angular.module('core')
    .directive('jsonDate', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {

                function padTo2Digits(num) {
                    return num.toString().padStart(2, '0');
                }

                //model to view
                ngModel.$formatters.push(value => {
                    if (!value)
                        return;

                    return new Date(value);
                });

                //view to model
                ngModel.$parsers.push(date => {
                    if (!date)
                        return date;

                    if (typeof date === 'object' && date._isAMomentObject === true) {
                        date = date.toDate()
                    }
                    return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join("-")
                });
            }
        }
    })
